// extracted by mini-css-extract-plugin
export default {"topSeparator":"AdministrarTransferencia_topSeparator__X12pl"};